<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" class="icon-magnifier">
    <g transform="translate(14685 5618)">
      <use class="svg-colorized-el" transform="translate(-14685 -5618)" :xlink:href="`#${id}_icon-magnifier_fill`"/>
      <mask :id="`${id}_a`">
        <use transform="translate(-14685 -5618)" :xlink:href="`#${id}_icon-magnifier_fill`"/>
      </mask>
      <g :mask="`url(#${id}_a)`" class="icon-magnifier_g">
        <use class="svg-colorized-el" transform="translate(-14685 -5618)" :xlink:href="`#${id}_icon-magnifier_stroke`"/>
      </g>
    </g>
    <defs>
      <path :id="`${id}_icon-magnifier_fill`" d="M13.787 12.752l-3.451-3.466a5.519 5.519 0 0 0 1.373-3.634C11.71 2.536 9.084 0 5.856 0 2.626 0 0 2.536 0 5.652c0 3.117 2.626 5.653 5.855 5.653a5.936 5.936 0 0 0 3.354-1.023l3.477 3.492a.771.771 0 0 0 .55.226.774.774 0 0 0 .53-.206.72.72 0 0 0 .021-1.042zM5.855 1.475c2.386 0 4.327 1.874 4.327 4.177 0 2.304-1.941 4.178-4.327 4.178S1.527 7.956 1.527 5.652c0-2.303 1.942-4.177 4.328-4.177z"/>
      <path :id="`${id}_icon-magnifier_stroke`" d="M13.787 12.752l.709-.706-.709.706zm-3.451-3.466l-.754-.657-.612.703.657.66.709-.706zm-1.127.996l.709-.706-.585-.586-.685.465.561.827zm3.477 3.492l-.708.706.708-.706zm1.08.02l-.68-.732.68.732zm.73-1.748l-3.452-3.465-1.417 1.411 3.452 3.465 1.417-1.41zM11.09 9.943a6.52 6.52 0 0 0 1.62-4.29h-2a4.519 4.519 0 0 1-1.128 2.976l1.508 1.314zm1.62-4.29C12.71 1.95 9.601-1 5.854-1v2c2.71 0 4.854 2.12 4.854 4.652h2zM5.854-1C2.108-1-1 1.95-1 5.652h2C1 3.121 3.145 1 5.855 1v-2zM-1 5.652c0 3.702 3.108 6.653 6.855 6.653v-2C3.145 10.305 1 8.185 1 5.652h-2zm6.855 6.653c1.41 0 2.76-.412 3.915-1.195L8.648 9.455c-.82.556-1.779.85-2.793.85v2zM8.5 10.988l3.478 3.492 1.417-1.412-3.477-3.492L8.5 10.988zm3.478 3.492c.337.338.789.52 1.259.52v-2a.23.23 0 0 1 .158.068l-1.417 1.412zm1.259.52c.445 0 .878-.165 1.21-.473l-1.362-1.465a.226.226 0 0 1 .152-.062v2zm1.21-.473a1.72 1.72 0 0 0 .049-2.48l-1.417 1.41a.28.28 0 0 1 .006-.395l1.362 1.465zM5.855 2.475c1.867 0 3.327 1.459 3.327 3.177h2c0-2.888-2.422-5.177-5.327-5.177v2zm3.327 3.177c0 1.72-1.46 3.178-3.327 3.178v2c2.905 0 5.327-2.289 5.327-5.178h-2zM5.855 8.83c-1.868 0-3.328-1.459-3.328-3.178h-2c0 2.89 2.423 5.178 5.328 5.178v-2zM2.527 5.652c0-1.718 1.46-3.177 3.328-3.177v-2C2.95.475.527 2.764.527 5.652h2z"/>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    id: String,
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/IconMagnifier.vue